export class Dollar {
    value: number;
    model: string;
    sign: string;
    inValid: boolean;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/dollar-model.ts